import { useState } from 'react';
import { User } from 'lucide-react';

/**
 * Avatar con fallback en cascada: imagen → iniciales → ícono.
 * El onError detecta fallos de carga (URL caída, CORS, etc.).
 */
const SIZES = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-14 w-14 text-base',
};

const getInitials = (name) => {
  if (!name) return '';
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0])
    .join('')
    .toUpperCase();
};

const Avatar = ({ src, name, size = 'md', className = '' }) => {
  const [hasError, setHasError] = useState(false);
  const initials = getInitials(name);
  const showImage = src && !hasError;

  return (
    <div
      className={[
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-brand-100 font-semibold text-brand-800',
        SIZES[size],
        className,
      ].join(' ')}
      aria-label={name || 'Usuario'}
    >
      {showImage ? (
        <img
          src={src}
          alt=""
          onError={() => setHasError(true)}
          className="h-full w-full object-cover"
          referrerPolicy="no-referrer"
        />
      ) : initials ? (
        <span aria-hidden="true">{initials}</span>
      ) : (
        <User className="h-1/2 w-1/2" aria-hidden="true" />
      )}
    </div>
  );
};

export default Avatar;